import { boot } from 'quasar/wrappers'
import VueApexCharts from 'vue-apexcharts'

export default boot(async ({ Vue }) => {
  Vue.component('ApexChart', VueApexCharts)
})
